import { faLineChart } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@mui/material';
import React from 'react';
import { generatePath, NavLink } from 'react-router-dom';

import { ADMIN_CONTRACT_REPORTS_URL } from '../../constants/routeUrls';

interface LinkToContractReportsPageProps {
  contractId: Number;
  // When true, render the legacy icon-only link (used in tight cells like the contract-list grid).
  compact?: boolean;
  // Override the default "View Performance" label.
  label?: string;
  // When set, appends ?lineItemId=N so the reports page can pre-filter charts by that line item.
  selectedLineItemId?: number;
  // Optional click handler — useful for callers that need to close a modal before navigation.
  onClick?: React.MouseEventHandler;
}

function ContractReportsPageLink({
  contractId,
  compact = false,
  label = 'View Performance',
  selectedLineItemId,
  onClick,
}: LinkToContractReportsPageProps) {
  const basePath = generatePath(ADMIN_CONTRACT_REPORTS_URL, { id: contractId.toString() });
  const to = selectedLineItemId != null ? `${basePath}?lineItemId=${selectedLineItemId}` : basePath;

  if (compact) {
    return (
      <NavLink to={to} onClick={onClick}>
        <Tooltip title="Performance Report" placement="top-end">
          <FontAwesomeIcon icon={faLineChart} color="rgba(0, 0, 0, 0.54)" />
        </Tooltip>
      </NavLink>
    );
  }

  return (
    <Button
      component={NavLink}
      to={to}
      onClick={onClick}
      variant="contained"
      color="success"
      startIcon={<FontAwesomeIcon icon={faLineChart} />}
      sx={{ color: '#fff' }}
    >
      {label}
    </Button>
  );
}

export default ContractReportsPageLink;
